import type { AnalyticsGranularity, AnalyticsPeriod } from '../api/types';

const PERIODS: readonly AnalyticsPeriod[] = [7, 30, 90];
const GRANULARITIES: readonly AnalyticsGranularity[] = ['daily', 'weekly', 'monthly'];

export function parsePeriod(raw: string | null): AnalyticsPeriod {
  const n = raw != null && raw !== '' ? Number(raw) : 7;
  if (PERIODS.includes(n as AnalyticsPeriod)) {
    return n as AnalyticsPeriod;
  }
  return 7;
}

export function parseGranularity(raw: string | null): AnalyticsGranularity {
  if (raw === 'weekly' || raw === 'monthly' || raw === 'daily') {
    return raw;
  }
  return 'daily';
}

export function periodOptions(): readonly AnalyticsPeriod[] {
  return PERIODS;
}

export function granularityOptions(): readonly AnalyticsGranularity[] {
  return GRANULARITIES;
}
